// @flow

import React, { Component } from 'react'

import './Paginate.css'

type Props = {
  changePage: Function,
  length: number,
  page: number
}

/**
  * Button for pagination
  * @class
  * @extends Component
*/
class Paginate extends Component<Props> {
  /** render function */
  render () {
    const buttons = []

    const start = Math.max(1, this.props.page - 2)
    const end = Math.min(start + 4, this.props.length)
    const previous5 = this.props.page - 5 < 1 ? 1 : this.props.page - 5
    const next5 = this.props.page + 5 > this.props.length ? this.props.length : this.props.page + 5

    for (let i = start; i <= end; i++) {
      buttons.push(<li className={(this.props.page === i) ? 'active' : ''} key={i} onClick={() => this.props.changePage(i)}>{i}</li>)
    }

    const previousButton = this.props.page === 1 ? <button className='disabled'>Previous</button> : <button className='previous' onClick={() => this.props.changePage(this.props.page - 1)}>Previous</button>
    const previous5Button = this.props.page < 4 ? <button className='disabled'>Previous 5</button> : <button className='previous' onClick={() => this.props.changePage(previous5)}>Previous 5</button>
    const nextButton = this.props.page >= this.props.length ? <button className='disabled'>Next</button> : <button className='next' onClick={() => this.props.changePage(this.props.page + 1)}>Next</button>
    const next5Button = this.props.page >= this.props.length - 2 ? <button className='disabled'>Next 5</button> : <button className='next' onClick={() => this.props.changePage(next5)}>Next 5</button>
    const firstButton = this.props.page === 1 ? <button className='disabled'>First</button> : <button className='previous' onClick={() => this.props.changePage(1)}>First</button>
    const lastButton = this.props.page >= this.props.length ? <button className='disabled'>Last ({this.props.length})</button> : <button className='next' onClick={() => this.props.changePage(this.props.length)}>Last ({this.props.length})</button>
    return (
      <div className='pagination'>
        <div className='leftButtons'>
          {firstButton}
          {previous5Button}
          {previousButton}
        </div>
        <ul className='pages'>{(this.props.length > 1) ? buttons : ''}</ul>
        <div className='rightButtons'>
          {nextButton}
          {next5Button}
          {lastButton}
        </div>
      </div>
    )
  }
}

export default Paginate
